<template>
  <div class="u-row">
    <a href="https://twitter.com/brig_ht?lang=fr" target="_blank">
      <svg class="t-icon t-icon--m u-marg-x-sm u-w2of12">
        <use xlink:href="#icon-twitter"/>
      </svg>
    </a>
    <a href="https://www.facebook.com/brightforme/" target="_blank">
      <svg class="t-icon t-icon--m u-marg-x-sm u-w2of12">
        <use xlink:href="#icon-facebook"/>
      </svg>
    </a>
    <a href="https://www.instagram.com/brig_ht/" target="_blank">
      <svg class="t-icon t-icon--m u-marg-x-sm u-w2of12">
        <use xlink:href="#icon-instagram"/>
      </svg>
    </a>
    <a href="https://www.linkedin.com/company/brightparis/" target="_blank">
      <svg class="t-icon t-icon--m u-marg-x-sm u-w2of12">
        <use xlink:href="#icon-linkedin"/>
      </svg>
    </a>
  </div>
</template>

<script>

export default {

}
</script>

<style lang="stylus">

</style>